import { api } from "./index";

export function getMultitenant(params) {
  return api.get("/multitenant", {
    params,
  });
}
